import { useEffect } from 'react'
import { getCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setCustomerName } from 'redux/actions'

interface useInitCentersProps {
  getRows: Function
  setRows: Function
  setCurrentCustomer: Function
  setDataLoaded: Function
  customerName: string
}

const useInit = (props: useInitCentersProps) => {
  useEffect(() => {
    props.getRows().then((data: any) => {
      props.setRows(data.customers)
      const currentCustomer = data.selectedCustomer ?? getCustomData('customer')
      const customerObj = data.customers.find((row) => row.id === currentCustomer?.data.id)
      props.setCurrentCustomer(customerObj)
      Store.dispatch(setCustomerName(customerObj.name))
      props.setDataLoaded(true)
    })
  }, [])
}

export default useInit
